import { useQuery } from "@tanstack/react-query";
import { getMyStreaks } from "@/lib/social.functions";
import { useLanguage } from "@/hooks/useLanguage";
import { Flame } from "lucide-react";

const TYPE_LABEL: Record<string, string> = {
  prediction: "streak_prediction",
  hype: "streak_hype",
  login: "streak_login",
  referral: "streak_referral",
};

export function StreakBadge() {
  const { t } = useLanguage();
  const q = useQuery({ queryKey: ["social", "streaks"], queryFn: () => getMyStreaks(), refetchInterval: 60_000 });
  const streaks = q.data?.streaks ?? [];
  if (streaks.length === 0) return null;

  return (
    <section className="rounded-2xl border border-border bg-background/60 p-4">
      <header className="mb-3 flex items-center gap-2">
        <Flame className="h-4 w-4 text-[oklch(0.78_0.2_60)]" />
        <h3 className="text-sm font-black uppercase tracking-wider">{t("streaks_title")}</h3>
      </header>
      <ul className="grid grid-cols-2 gap-2">
        {streaks.map((s) => {
          const c = Number(s.current_count ?? 0);
          const heat = Math.min(1, c / 10);
          return (
            <li
              key={s.streak_type as string}
              className="rounded-xl border border-border bg-background px-3 py-2"
              style={{ boxShadow: c >= 3 ? `0 0 ${4 + heat * 16}px oklch(0.78 0.2 60 / ${0.3 + heat * 0.4})` : undefined }}
            >
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground">
                {t(TYPE_LABEL[s.streak_type as string] ?? "streak_prediction")}
              </div>
              <div className="mt-0.5 font-mono text-lg font-black tabular-nums">
                {c}{c >= 3 ? <span className="ml-1">🔥</span> : null}
              </div>
              <div className="text-[10px] text-muted-foreground">
                {t("streaks_best")} {Number(s.best_count ?? 0)}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}